<template lang="pug">
  #challenge-entities
    WtEntityTable(
      :data="challengeEntities"
      :pagination-object="challengeEntitiesPagination"
      :fetch-action="fetchAction"
      :show-title="false"
      default-sort-field="name"
      :enable-search="true"
      @search="onSearch($event)"
      :enable-remove="!challengeComplete"
      @remove="removeEntityFromChallenge($event)"
      empty-message="No participants yet."
      @fetchActionResponse="fetchActionResponse($event)"
    )
      BTableColumn(:field="entity.field" :label="_.capitalize(entity.field)" width="8rem" v-slot="column")
        .media
          .media-left
            // TODO change to EntityImage
            EntityAvatar(:image="column.row[entity.image]" size-class="is-64x64" is-rounded)
          .media-content
            WtTableCellLongText(:text="column.row[entity.field]")

</template>

<script>
import { mapActions } from "vuex";
import tablePropsMixin from "@/mixins/tablePropsMixin";
import WtButton from "@@/WtButton/WtButton";
import WtTitle from "@@/WtTitle/WtTitle";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";
import WtTableCellLongText from "@@/WtTableCellLongText/WtTableCellLongText";

import EntityAvatar from "@/components/WtEntityAvatar/WtEntityAvatar";

export default {
  name: "ChallengeEntities",

  components: {
    EntityAvatar,
    WtButton,
    WtTitle,
    WtEntityTable,
    WtTableCellLongText
  },

  mixins: [tablePropsMixin],

  props: {
    challenge: {
      type: Object,
      required: true
    },

    isTeamEdit: {
      type: Boolean,
      default: false
    },

    showTitle: {
      type: Boolean,
      default: false
    },

    challengeComplete: {
      type: Boolean,
      default: false
    },

    removeTeamCallback: {
      type: Function,
      default: () => {}
    }
  },

  data() {
    return {
      challengeEntities: [],
      challengeEntitiesPagination: {},
      challengeEntitiesLoaded: false
    };
  },

  computed: {
    entity() {
      return this.challenge.between === "groups"
        ? { type: "teams", field: "name", image: "logo" }
        : { type: "members", field: "name", image: "avatar" };
    }
  },

  async mounted() {
    await this.fetchChallengeEntities({
      challengeId: this.challenge.id,
      entity: this.entity.type
    }).then(response => {
      this.challengeEntities = response.data;
      this.challengeEntitiesPagination = response.pagination;
    });
    this.challengeEntitiesLoaded = true;

    this.onSearch = this._.debounce(async query => {
      await this.fetchChallengeEntities({
        challengeId: this.challenge.id,
        entity: this.entity.type,
        searchTerm: query
      }).then(response => {
        this.challengeEntities = response.data;
        this.challengeEntitiesPagination = response.pagination;
      });
    }, 500);
  },

  methods: {
    ...mapActions("challenges", [
      "fetchChallengeEntities",
      "removeMembersFromChallenge",
      "removeTeamsFromChallenge"
    ]),
    ...mapActions("pages", ["setPageLoaded"]),

    async fetchAction(payload) {
      return await this.fetchChallengeEntities({
        ...payload,
        challengeId: this.challenge.id,
        entity: this.entity.type
      });
    },

    onSearch() {},
    fetchActionResponse(response) {
      this.challengeEntities = response.data;
      this.challengeEntitiesPagination = response.pagination;
    },

    removeEntityFromChallenge(entity) {
      if (this.entity.type === "members") {
        this.$buefy.dialog.confirm({
          title: "Remove Member From Challenge",
          confirmText: "Remove Member From Challenge",
          type: "is-danger",
          hasIcon: true,
          message:
            "Are you sure you want to remove member from this challenge?",
          onConfirm: async () => {
            this.removeMembersFromChallenge({
              challengeId: this.challenge.id,
              memberIds: [entity.id]
            });
            this.challengeEntities = this.challengeEntities.filter(
              member => member.id !== entity.id
            );
            this.setPageLoaded({ key: "MyDashboard", value: false });
            this.setPageLoaded({ key: "Challenges", value: false });
          }
        });
      }

      if (this.entity.type === "teams") {
        this.$buefy.dialog.confirm({
          title: "Remove Team From Challenge",
          confirmText: "Remove Team From Challenge",
          type: "is-danger",
          hasIcon: true,
          message: "Are you sure you want to remove team from this challenge?",
          onConfirm: async () => {
            await this.removeTeamsFromChallenge({
              challengeId: this.challenge.id,
              teamIds: [entity.id]
            });
            this.challengeEntities = this.challengeEntities.filter(
              team => team.id !== entity.id
            );
            this.setPageLoaded({ key: "MyDashboard", value: false });
            this.setPageLoaded({ key: "Challenges", value: false });
            this.removeTeamCallback();
          }
        });
      }
    }
  }
};
</script>

<style lang="sass" scoped></style>
